import moment from 'moment';
import { message } from 'antd';
import { getScanDateList, getData } from '@/components/report/service';
import { computeWeight } from '@/utils/query';
import { TableQuery } from '../Filter';

// const ateRange = [
//   moment(new Date()).add(0, 'days').format('YYYY-MM-DD 12:00:00'),
//   moment(new Date()).add(1, 'days').format('YYYY-MM-DD 12:00:00')
// ]
const paramsForm = {
  startDate: moment(new Date()).add(-1, 'days').format('YYYY-MM-DD'),
  endDate: moment(new Date()).add(0, 'days').format('YYYY-MM-DD'),
}

export default {
  namespace: 'estimatedVolumeView',
  state: {
    filter: { ...paramsForm },
    defualtDateFormat: 'YYYY-MM-DD',

    tableItem: [],
  },
  effects: {
    *resetSearch(_, { put }) {
      yield put({
        type: 'update',
        payload: {
          filter: { ...paramsForm }
        },
      });
    },
    *getSelect({ payload }, { put }) {
      yield put({
        type: 'update',
        payload: { ...payload },
      });
    },
    *getData(_, { call, put, select }) {
      let query = yield select(({ estimatedVolumeView }) => {
        const { startDate, endDate } = estimatedVolumeView.filter;
        return {
          startDate,
          endDate
        }
      });
      const params = {
        startDate: query.startDate + ' 23:00:00',
        endDate: query.endDate + ' 00:00:00',
      }
      const filter = TableQuery(params)
      const data = yield call(getScanDateList, filter[0]);


      if (data && data.code === 1) {
        const tableData = JSON.parse(data.data || null);
        if (data.error) {
          message.error({ title: '查询出现错误', description: data.data })
          return
        }
        const tempData = []
        tableData.map(item => tempData.push(...item.events))
        const waybillNos = tempData.map(item => item.waybillNo);
        const result = [];
        const filter2 = TableQuery({ ...params, ...{ waybillNos: waybillNos } });
        const calcWeightData = yield call(getData, filter2[1]);
        const newCalcWeightData = calcWeightData || [];

        for (let i = 0; i < filter2[2].length; i++) {
          const d = yield call(getScanDateList, filter2[2][i]);
          if (d && d.code === 1) {
            if (d.error) {
              message.error({ title: '查询出现错误', description: d.data })
              return
            }
            const dData = JSON.parse(d.data || null);
            const dTempData = []
            dData.map(item => dTempData.push(...item.events))
            result[i] = dTempData
          }

        }

        tempData.forEach((item, index) => {
          item.index = index;
          item.time2 = moment(item.__time).utc().format('YYYY-MM-DD HH:mm:ss');
          item.originCenter = item.originCenter ? item.originCenter.replace('分拨中心', '') : '--';
          item.destinationCenter = item.destinationCenter ? item.destinationCenter.replace('分拨中心', '') : '--';
          // 结算重量
          const calcWeightObj = newCalcWeightData.find(item2 => item2.waybillNo === item.waybillNo);
          item.calcWeight = calcWeightObj ? computeWeight(calcWeightObj.calcWeight) : 0;

          result.forEach((item2, index2) => {
            const obj = item2.find(item3 => item3.waybillNo === item.waybillNo);
            item[`time_${index2}`] = obj ? moment(obj.__time).utc().format('YYYY-MM-DD HH:mm:ss') : '--';
          })
        })

        yield put({
          type: 'update',
          payload: {
            tableItem: tempData
          },
        });
      } else {
        yield put({
          type: 'update',
          payload: {
            tableItem: []
          },
        });
      }
    },
  },
  reducers: {
    update(state, { payload }) {
      return { ...state, ...payload };
    }
  }
}
